import React from "react";
import { StyledButton } from "./styled";

function MapButton({ className, children, label, type, isActive, ...props }) {
  return (
    <StyledButton
      className={className}
      type={type}
      isActive={isActive}
      aria-label={label}
      {...props}
    >
      {children}
    </StyledButton>
  );
}

export default MapButton;
